/** Clé de l'api Google Maps, partagée par les cartes des pages Communes et Imports */
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDrWtCIcfA21x2Vw0lbe8kOEJlnvbfkJYs';
